import React from "react";
import HowToUseIframe from '../components/HowToUseIframe';

const HowToUse = () => {
  return (
    <div>
      <HowToUseIframe
        source={''}
      />
    </div>
  );
};

export default HowToUse;